<ng-container *ngIf="field.type === CustomFieldTypesEnum.TEXT">
  <app-custom-field-text-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-text-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.TEXTAREA">
  <app-custom-field-textarea-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-textarea-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.EMAIL">
  <app-custom-field-email-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-email-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.URL">
  <app-custom-field-url-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-url-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.NUMBER">
  <app-custom-field-number-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-number-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.PERCENT">
  <app-custom-field-percent-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-percent-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.PHONE">
  <app-custom-field-phone-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-phone-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.DATE">
  <app-custom-field-date-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [params]="params"
    [data]="data">
  </app-custom-field-date-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.DATE_TIME">
  <app-custom-field-date-time-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-date-time-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.DATE_PERIOD">
  <app-custom-field-date-period-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-date-period-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.DATE_TIME_PERIOD">
  <app-custom-field-date-time-period-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-date-time-period-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.SWITCHER">
  <app-custom-field-switcher-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-switcher-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.SELECT">
  <app-custom-field-picklist-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-picklist-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.RADIO_BUTTON">
  <app-custom-field-radio-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-radio-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.CHECKBOX">
  <app-custom-field-checkbox-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-checkbox-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.MULTISELECT">
  <app-custom-field-multiselect-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-multiselect-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.NUMERATION">
  <app-custom-field-numeration-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-numeration-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.LOOKUP">
  <app-custom-field-lookup-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data"
    [filter]="filter"
    [params]="params"
    [allowTextAsValue]="allowTextAsValue"
    [waitFocusCallback]="waitFocusCallback"
    (focusEvent)="focusEvent.emit($event)">
  </app-custom-field-lookup-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.LOOKUP_ACTION">
  <app-custom-field-lookup-action-value-edit
    #fieldEl
    [objectName]="objectName"
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-lookup-action-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.DECIMAL_NUMBER">
  <app-custom-field-decimal-number-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-decimal-number-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.TIME">
  <app-custom-field-time-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-time-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.ANALITIKE">
  <app-custom-field-analitike-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-analitike-value-edit>
</ng-container>
<ng-container *ngIf="field.type === CustomFieldTypesEnum.KONTO_ANALITIKE">
  <app-custom-field-konto-analitike-value-edit
    #fieldEl
    [customField]="field"
    [label]="label"
    [controlName]="controlName"
    [data]="data">
  </app-custom-field-konto-analitike-value-edit>
</ng-container>
